import { z } from 'zod';
/**
 * Attachments are screenshots pasted into rich text and attached to steps.
 * Only raster images are accepted, and the type is verified against the file's
 * own magic bytes on upload — the declared content type is not trusted.
 */
export const ATTACHMENT_MIME_TYPES = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
];
export const MAX_ATTACHMENT_BYTES = 5 * 1024 * 1024;
export const attachmentMimeTypeSchema = z.enum(ATTACHMENT_MIME_TYPES);
/** The public URL an attachment is served from (also the only `img` src the renderer accepts). */
export const ATTACHMENT_URL_PREFIX = '/api/v1/attachments/';
export const attachmentUrl = (id) => `${ATTACHMENT_URL_PREFIX}${id}`;
/** `true` for the URLs this application serves itself, `false` for anything remote. */
export const isAttachmentUrl = (url) => /^\/api\/v1\/attachments\/[0-9a-f-]{36}$/i.test(url);
//# sourceMappingURL=attachment.js.map